"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createChipTheme = void 0;
exports.createChipTheme = function (_a) {
    var palette = _a.palette;
    return ({
        root: {
            height: 28,
        },
        label: {
            fontFamily: "Gilroy",
            fontWeight: 500,
            fontSize: 10,
            paddingRight: 20,
            paddingLeft: 20,
        },
        colorPrimary: {
            color: palette.primary.main,
            backgroundColor: "#f5f8fd",
        },
        colorSecondary: {
            color: palette.secondary.main,
            backgroundColor: "#faf5fd",
        },
        icon: {
            width: 13,
            height: 13,
            marginLeft: 16,
            marginRight: -16,
        },
    });
};
